<template>
  <cvc-view>
    <notifications-tool-bar />
    <v-container>
      <router-view />
    </v-container>
  </cvc-view>
</template>

<script>
import CvcView from "@/components/CvcView";
import NotificationsToolBar from "@/components/NotificationsToolBar";
export default {
  name: "Notifications",
  components: { NotificationsToolBar, CvcView },
};
</script>
